import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { AppProviders } from '@/app/AppProviders';
import '@/styles/global.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container #root was not found in the document.');
}

// The prerendered page ships its metadata in the static HTML for crawlers.
// React renders the same tags from `buildPageMeta`, so the static ones are
// removed first to avoid duplicate titles and canonical links.
for (const element of document.querySelectorAll('[data-prerendered-seo]')) {
  element.remove();
}

createRoot(container).render(
  <StrictMode>
    <AppProviders />
  </StrictMode>,
);
